/**
 * useInventoryGroupEntryScreen.js
 * -------------------------------
 * Hook for Inventory Group create/edit form screen using shared useMasterEntry.
 */
import { useMasterEntry } from '../../common/useMasterEntry';
import * as inventoryGroupApi from '../api/inventoryGroupApi';

export function useInventoryGroupEntryScreen() {
  return useMasterEntry({
    entityName: 'Inventory Group',
    apiClient: inventoryGroupApi.inventoryGroupClient,
    fetchDetail: inventoryGroupApi.getInventoryGroupDetail,
    createItem: inventoryGroupApi.createInventoryGroup,
    updateItem: inventoryGroupApi.updateInventoryGroup,
    initialForm: {
      name: '',
    },
    validate: (form) => {
      if (!form.name || !form.name.trim()) {
        return 'Group Name is required.';
      }
      return null;
    },
    listPath: '/masters/inventory-group/list',
  });
}
